import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Fondo from "../../../images/modulo6/fondoaula.png";
import Imagen1 from "../../../images/modulo6/simbolomapa.png";
import Imagen2 from "../../../images/modulo6/simbolobandera1.png";
import Imagen3 from "../../../images/modulo6/simbolobandera2.png";
import Imagen4 from "../../../images/modulo6/simbolohimno.png";
import Imagen5 from "../../../images/modulo6/simboloescudo.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo6 } from "../../../routes/Module6";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo6/Actividad 4.mp3";

const Actividad4 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "símbolos" },
    ans2: { value: "", valid: "", correctValue: "independencia" },
    ans3: { value: "", valid: "", correctValue: "bandera" },
    ans4: { value: "", valid: "", correctValue: "himno" },
    ans5: { value: "", valid: "", correctValue: "escudo" },
  });
  const infoUnidad = modulo6.content[0];
  const infoAct = modulo6.content[0].activities[3];
  const crumbs = [
    {
      title: modulo6.title,
      url: "/" + modulo6.url,
    },
    {
      title:
        modulo6.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo6.content[0].activities[4].name}`,
    linkNext: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[4].path}`,
    titlePrev: `${modulo6.content[0].activities[2].name}`,
    linkPrev: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[2].path}`,
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const metadata = {
    color: modulo6.color,
    title: `${modulo6.title} - ${infoAct.name}`,
    name: modulo6.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo6.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>
          ¿De qué están hablando nuestros amigos? Escribe las palabras que
          faltan. Tómalas del recuadro.
        </li>
      </ul>
      <div className="row justify-content-center">
        <div className="col-md-8 col-xs-12 ms-4">
          <Card>
            <div className="d-flex flex-wrap justify-content-around">
              <div className="px-1">himno</div>
              <div className="px-1">escudo</div>
              <div className="px-1">independencia</div>
              <div className="px-1">símbolos</div>
              <div className="px-1">bandera</div>
            </div>
          </Card>
        </div>
      </div>

      <div
        style={{ backgroundImage: "url(" + Fondo + ")" }}
        className="bg-aula"
      >
        <div className="row activities-content mt-5 align-items-center">
          <div className="col-md-3 col-xs-12 mb-5">
            <Card>
              <div>
                Todos los países necesitan objetos, palabras o imágenes que los
                identifiquen y los diferencien de otros países. Se llaman{" "}
                <input
                  type="text"
                  className={
                    "form-control form-control-sm " + answers.ans1.valid
                  }
                  value={answers.ans1.value}
                  onChange={(event) => handleAnswers(event, "ans1")}
                />{" "}
                nacionales.
              </div>
            </Card>
          </div>
          <div className="col-md-3 col-xs-12">
            <img src={Imagen1} alt="Familia" className="img-fluid mb-1" />
          </div>
          <div className="col-md-3 col-xs-12">
            <img src={Imagen2} alt="Familia" className="img-fluid mb-1" />
          </div>
          <div className="col-md-3 col-xs-12">
            <Card>
              Los símbolos nacionales del Perú se crearon cuando empezamos a ser
              un país libre, es decir, cuando nuestro país luchaba por su{" "}
              <input
                type="text"
                className={"form-control form-control-sm" + answers.ans2.valid}
                value={answers.ans2.value}
                onChange={(event) => handleAnswers(event, "ans2")}
              />
              de España.
            </Card>
          </div>

          <div className="col-md-3 offset-md-1 col-xs-12 mb-5">
            <img src={Imagen3} alt="Familia" className="img-fluid" />

            <Card>
              Uno de los símbolos nacionales del Perú es la{" "}
              <input
                type="text"
                className={"form-control form-control-sm " + answers.ans3.valid}
                value={answers.ans3.value}
                onChange={(event) => handleAnswers(event, "ans3")}
              />
              . Sus colores son rojo y blanco.
            </Card>
          </div>
          <div className="col-md-3 col-xs-12 mb-5">
            <img src={Imagen4} alt="Familia" className="img-fluid mb-1" />
            <Card>
              También los cantos pueden ser símbolos nacionales. Nuestro
              <input
                type="text"
                className={"form-control form-control-sm " + answers.ans4.valid}
                value={answers.ans4.value}
                onChange={(event) => handleAnswers(event, "ans4")}
              />
              celebra que somos un país libre, por eso su coro empieza con
              “Somos libres”.
            </Card>
          </div>
          <div className="col-md-3 col-xs-12 mb-5">
            <img src={Imagen5} alt="Familia" className="img-fluid mb-1" />
            <Card>
              Este es otro de nuestros símbolos nacionales. Incluye elementos de
              nuestro país que nos representan.
              <br /> Su nombre es
              <input
                type="text"
                className={
                  "form-control form-control-inline form-control-sm " +
                  answers.ans5.valid
                }
                value={answers.ans5.value}
                onChange={(event) => handleAnswers(event, "ans5")}
              />
              nacional.
            </Card>
          </div>
        </div>
      </div>

      <div className="d-flex w-100 justify-content-end mb-4">
        <button
          className={`btn btn-${modulo6.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes y conversen acerca de lo
          que están haciendo los personajes (decorar el aula por Fiestas
          Patrias). Lean los diálogos en voz alta. Ayude a responder. Recalque
          que esos son los tres símbolos nacionales peruanos.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
